import { render, staticRenderFns } from "./lotteryPage.vue?vue&type=template&id=d55b479a&scoped=true&class=roombox"
import script from "./lotteryPage.vue?vue&type=script&lang=js"
export * from "./lotteryPage.vue?vue&type=script&lang=js"
import style0 from "./lotteryPage.vue?vue&type=style&index=0&id=d55b479a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55b479a",
  null
  
)

export default component.exports